// extracted by mini-css-extract-plugin
module.exports = {"custom-input":"dropdown-module__custom-input___TKwZX","customInput":"dropdown-module__custom-input___TKwZX"};